<template>
<div>
  <cube-form
    ref="form1"
    :model="model1"
    :schema="schema1"
    :options="options">
  </cube-form>
  <div
    v-if="model1._residentType==='nonResidents'||model1._residentType==='chinaAndOtherTax'"
  >
    <!-- :schema="schema2" -->
    <cube-form
      ref="form2"
      :model="model2"
      :options="options">
      <cube-form-group>
        <cube-form-item :field="schema2.groups[0].fields[0]"></cube-form-item>
        <cube-form-item :field="schema2.groups[0].fields[1]"></cube-form-item>
        <cube-form-item :field="schema2.groups[0].fields[2]">
          <cube-input placeholder="请选择出生日期" :readonly="true" @click.native="showDatePicker" :value="model2.birthday"></cube-input>
          <cube-date-picker
            ref="datePicker"
            :min="new Date(1900, 0, 1)"
            :max="new Date()"
            @select="dateSelectHandler"
            :value="new Date(model2.birthday)"
          ></cube-date-picker>
        </cube-form-item>
      </cube-form-group>
      <cube-form-group legend="现居地址">
        <cube-form-item :field="schema2.groups[1].fields[0]"></cube-form-item>
        <cube-form-item :field="schema2.groups[1].fields[1]"></cube-form-item>
      </cube-form-group>
      <cube-form-group legend="出生地址">
        <cube-form-item :field="schema2.groups[2].fields[0]"></cube-form-item>
        <cube-form-item :field="schema2.groups[2].fields[1]"></cube-form-item>
      </cube-form-group>
    </cube-form>
    <tax-common ref="taxCommon"></tax-common>
  </div>

</div>

</template>

<script>
import { mapState } from 'vuex';

import TaxCommon from '@/components/tax/TaxCommon.vue';
import { createToast, regexTestDate } from '@/utils';
import filters from '@/filters/index';


export default {
  name: 'TaxOrg',

  components: {
    TaxCommon,
  },

  data() {
    return {
      model1: {
        investorName: '', // 姓名
        _residentType: '', // 单选框: - 居民类型
      },
      schema1: {
        groups: [
          {
            fields: [
              {
                type: 'input',
                modelKey: 'investorName',
                label: '姓名',
                props: [{ disabled: true }],
              },
            ],
          },
          {
            legend: '本人声明',
            fields: [
              {
                type: 'radio-group',
                modelKey: '_residentType',
                props: [{
                  class: 'radio-row',
                  options: [
                    {
                      label: '仅为中国税收居民',
                      value: 'chineseTaxResident',
                    },
                    {
                      label: '仅为非居民',
                      value: 'nonResidents',
                    },
                    {
                      label: '即是中国税收居民又是其他国家（地区）税收居民',
                      value: 'chinaAndOtherTax',
                    },
                  ],
                }],
                rules: {
                  required: true,
                },
                messages: {
                  required: '请选择税收身份',
                },
              },
            ],
          },
        ],
      },
      model2: {
        surname: '', // 姓（英文或拼音）
        name: '', // 名（英文或拼音）
        birthday: '', // 生日
        placeOfResidenceChinese: '', // 现居地址(中文)
        placeOfResidenceEnglish: '', // 现居地址(英文或拼音)
        placeOfBirthChinese: '', // 出生地址(中文)
        placeOfBirthEnglish: '', // 出生地址(英文或拼音)
      },
      schema2: {
        groups: [
          {
            legend: '基础信息',
            fields: [
              {
                type: 'input',
                modelKey: 'surname',
                label: '姓氏',
                props: [{ placeholder: '英文或拼音' }],
                rules: {
                  required: true,
                },
                messages: {
                  required: '请填写英文名称',
                },
              },
              {
                type: 'input',
                modelKey: 'name',
                label: '名字',
                props: [{ placeholder: '英文或拼音' }],
                rules: {
                  required: true,
                },
                messages: {
                  required: '请填写英文名称',
                },
              },
              {
                modelKey: 'birthday',
                label: '出生日期',
                rules: {
                  required: true,
                },
              },
            ],
          },
          {
            legend: '现居地址',
            fields: [
              {
                type: 'input',
                modelKey: 'placeOfResidenceChinese',
                label: '中文地址',
                props: [{ placeholder: '请用中文填写,境外地址可不填此项' }],
              },
              {
                type: 'input',
                modelKey: 'placeOfResidenceEnglish',
                label: '英文地址',
                props: [{ placeholder: '请用英文或拼音填写' }],
              },
            ],
          },
          {
            legend: '出生地址',
            fields: [
              {
                type: 'input',
                modelKey: 'placeOfBirthChinese',
                label: '中文地址',
                props: [{ placeholder: '请用中文填写,境外地址可不填此项' }],
              },
              {
                type: 'input',
                modelKey: 'placeOfBirthEnglish',
                label: '英文地址',
                props: [{ placeholder: '请用英文或拼音填写' }],
              },
            ],
          },
        ],
      },
      options: {
        scrollToInvalidField: true,
        // layout: 'standard', // classic fresh
      },
    };
  },

  computed: {
    ...mapState(['tax']),
  },

  methods: {
    // 打开日期选择
    showDatePicker() {
      this.$refs.datePicker.show();
    },
    dateSelectHandler(selectedVal) {
      this.model2.birthday = filters.formatDate(new Date(selectedVal));
    },
    async submit() {
      const model = {
        _signUserIdentity: 'signUserIdentityI',
      };
      await this.$refs.form1.validate().then(value => (value ? Promise.resolve() : Promise.reject()));
      Object.assign(model, this.model1);
      if (this.model1._residentType !== 'chineseTaxResident') {
        await this.$refs.form2.validate().then(value => (value ? Promise.resolve() : Promise.reject()));
        if (!this.model2.placeOfResidenceChinese && !this.model2.placeOfResidenceEnglish) {
          createToast.call(this, '现居地址至少填一个');
          return Promise.reject();
        }
        if (!this.model2.placeOfBirthChinese && !this.model2.placeOfBirthEnglish) {
          createToast.call(this, '出生地址至少填一个');
          return Promise.reject();
        }
        // 获取公共数据
        const modelCommon = await this.$refs.taxCommon.submit();
        Object.assign(model, this.model2, modelCommon);
      }
      return model;
    },
    initModel() {
      const { userInfo } = this.tax;
      this.model1.investorName = userInfo.invenstemName;
      this.model2.birthday = userInfo.idCardNo.substr(6, 8).replace(/(\d{2,4})(?=(\d{2})+$)/g, '$1-');
      if (!regexTestDate(this.model2.birthday)) {
        this.model2.birthday = '';
      }
    },
  },

  async created() {
    await this.tax.userInfoPromise;
    this.initModel();
  },
};
</script>

<style>

</style>
